import * as yup from 'yup';
import ticketIcon from 'assets/images/icons/ticket.svg';
import ringRedIcon from 'assets/images/icons/ring-red.svg';
import ringBlueIcon from 'assets/images/icons/ring-blue.svg';
import ringYellowIcon from 'assets/images/icons/ring-yellow.svg';

export const ticketHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'table_header_id',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'referenceNumber',
    populateFunc: 'populateTicketRefNumber',
  },
  {
    name: 'title',
    displayName: 'table_header_title',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'title',
  },
  {
    name: 'ticketType',
    displayName: 'table_header_ticket_type',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'ticketType.name',
    populateFunc: 'populateTicketType',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'description',
  },
  {
    name: 'priority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'priority',
    translateVal: true,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'dueDate',
    displayName: 'table_header_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'dueDate',
    populateFunc: 'populateDateTime',
  },
  {
    name: 'assignedTo',
    displayName: 'table_header_assigned_to',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'assignedTo',
    populateFunc: 'populateUsersAndGroups',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'status',
    populateFunc: 'populateTicketStatus',
  },
  {
    name: 'createdAt',
    displayName: 'table_header_created_at',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'createdAt',
    populateFunc: 'populateDateTime',
  },
  {
    name: 'createdBy',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'createdBy',
    populateFunc: 'populateUserNameWithInitialLetters',
  },
  {
    name: 'formTitle',
    displayName: 'table_header_form',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'formTitle',
  },
  {
    name: 'companyFieldsData',
    displayName: 'table_header_company_fields',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'companyFieldsData',
    populateFunc: 'populateCompanyFieldTitlesText',
    callbackFunc: 'resolveCompanyFieldsTitles',
  },
];

export const sortOptions = [
  { value: 'createdAt', displayValue: 'select_creation_date' },
  { value: 'updatedAt', displayValue: 'select_last_updated' },
  { value: 'dueDate', displayValue: 'select_due_date' },
];

export const ticketDueDateFilterOptions = [
  { value: 'all', displayValue: 'select_all' },
  { value: 'today', displayValue: 'select_due_today' },
  { value: 'next_seven_days', displayValue: 'select_due_next_seven_days' },
  { value: 'overdue', displayValue: 'select_overdue' },
  { value: 'custom', displayValue: 'select_custom' },
];

export const ticketCreatedDateFilterOptions = [
  { value: 'all', displayValue: 'select_all' },
  { value: 'today', displayValue: 'select_today' },
  { value: 'last_seven_days', displayValue: 'select_last_seven_days' },
  { value: 'last_thirty_days', displayValue: 'select_last_thirty_days' },
  { value: 'custom', displayValue: 'select_custom' },
];

export const ticketStatusFilterOptions = [
  { value: '', displayValue: 'select_all' },
  { value: 'open', displayValue: 'select_open' },
  { value: 'in-progress', displayValue: 'select_in_progress' },
  { value: 'resolved', displayValue: 'select_resolved' },
  { value: 'closed', displayValue: 'select_closed' },
];

export const ticketStatusUpdateOptions = [
  { value: 'open', displayValue: 'select_open', disabled: true },
  { value: 'in-progress', displayValue: 'select_in_progress' },
  { value: 'resolved', displayValue: 'select_resolved' },
  { value: 'closed', displayValue: 'select_closed', disabled: true },
];

export const ticketPriorityFilterOptions = [
  { value: '', displayValue: 'select_all' },
  { value: 'low', displayValue: 'select_low' },
  { value: 'medium', displayValue: 'select_medium' },
  { value: 'high', displayValue: 'select_high' },
];

export const ticketTypesHeaderList = [
  {
    name: 'name',
    displayName: 'table_header_type_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'name',
  },
  {
    name: 'defaultPriority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'defaultPriority',
    translateVal: true,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'edit_delete',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    populateFunc: 'populateEditType',
    translateVal: true,
    callbackFunc: 'actionOnclick',
  },
];

export const addTicketTypeSchema = yup.object({
  name: yup.string().required('Type name is required'),
  allowUserPrioritySelection: yup.boolean().required(),
  defaultPriority: yup
    .string()
    .nullable()
    .when('allowUserPrioritySelection', {
      is: false,
      then: (schema) => schema.required('Choose a priority if selection is disabled'),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export const ticketsTabsList = [
  {
    id: 1,
    title: 'tabs_tickets',
    value: 'tickets_list',
    breadcrumbValue: { icon: ticketIcon, items: ['sidebar_tickets', 'tabs_tickets'] },
  },
  {
    id: 2,
    title: 'tabs_types',
    value: 'tickets_types',
    breadcrumbValue: { icon: ticketIcon, items: ['sidebar_tickets', 'tabs_types'] },
  },
];

export const priorityOptionsList = [
  { value: 'low', displayValue: 'select_low', icon: ringBlueIcon },
  { value: 'medium', displayValue: 'select_medium', icon: ringYellowIcon },
  { value: 'high', displayValue: 'select_high', icon: ringRedIcon },
];
